import { useContext, useState } from "react";
import { GlobalIcon } from "get-life-storybook-ts";
import { I18nContext } from "../../../../../../context/i18n.context";

interface PolicyHeaderProps {
  policyNumber: string;
}

const PolicyHeader = ({ policyNumber }: PolicyHeaderProps) => {
  const {
    state: { translate },
  } = useContext(I18nContext);

  const [copied, setCopied] = useState(false);

  const copyPolicyNumber = () => {
    navigator.clipboard.writeText(policyNumber).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "flex-start",
        justifyContent: "space-between",
        gap: 12,
      }}
    >
      <div>
        <h1 style={{ fontSize: 24, fontWeight: 700, color: "#111827", margin: 0 }}>
          {translate("newDashboard.policyPage.title")}
        </h1>
        <p style={{ fontSize: 15, color: "#6b7280", marginTop: 4 }}>
          {translate("newDashboard.policyPage.subtitle")}
        </p>
      </div>
      <button
        onClick={copyPolicyNumber}
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          padding: "8px 16px",
          backgroundColor: copied ? "#ecfdf5" : "#f9fafb",
          border: `1px solid ${copied ? "#a7f3d0" : "#e5e7eb"}`,
          borderRadius: 8,
          cursor: "pointer",
          transition: "all 0.2s",
          fontSize: 13,
          fontWeight: 500,
          color: copied ? "#065f46" : "#6b7280",
        }}
        title="Copiar número de póliza"
      >
        <GlobalIcon
          iconName={copied ? "CheckedIcon" : "FileInvoiceIcon"}
          size="XS"
          color={copied ? "#059669" : "#9ca3af"}
        />
        {translate("newDashboard.policyPage.policyNumber")}: {policyNumber}
      </button>
    </div>
  );
};

export default PolicyHeader;
